// extracted by mini-css-extract-plugin
export default {"root":"Notification_root__24WiE"};